// extracted by mini-css-extract-plugin
export default {"group":"styles_group__wVNqN","grid":"styles_grid__he4D5","headerGrid":"styles_headerGrid__bYdng","error":"styles_error__NWMpw"};